export const SectionCard: React.FC<{
  title: string;
  badge?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, badge, children }) => (
  <div className="bg-white rounded-xl border border-gray-200/20 overflow-hidden mb-4 last:mb-0 shadow-sm">
    <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100/20 bg-gray-50/20">
      <span className="text-[11px] font-medium uppercase tracking-widest text-gray-400">
        {title}
      </span>
      {badge}
    </div>
    <div className="p-4">{children}</div>
  </div>
);
